import './ProcessingIcon.scss';

import classNames from 'classnames';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { ProcessingResult } from '@hooks';
import React from 'react';
import { SalesforceCloudError } from '@ui/icons/SalesforceCloudError';
import { Tooltip } from 'antd';
import { TooltipPlacement } from 'antd/es/tooltip';

import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { SalesforceCloudCheck, SalesforceCloudOutline } from '@ui/lottie';

export interface ProcessingIconProps {
	className?: string;
	errorsOnly?: boolean;
	isSalesforce?: boolean;
	isProcessing: boolean;
	placement?: TooltipPlacement;
	result?: ProcessingResult;
}

export const ProcessingIcon: React.FC<ProcessingIconProps> = ({
	className,
	isSalesforce,
	errorsOnly = !isSalesforce,
	isProcessing,
	placement = 'bottom',
	result
}) => {
	let icon = null;
	const success = result?.success && !errorsOnly;
	const error = result && !result.success;
	const processing = isProcessing && !errorsOnly;

	if (!isProcessing && !result) {
		return icon;
	}

	if (success) {
		icon = isSalesforce ? <SalesforceCloudCheck /> : <CheckCircleOutlined />;
	}

	if (error) {
		icon =
			<Tooltip
				placement={ placement }
				title={ result.message }>
				{ isSalesforce ? <SalesforceCloudError /> : <CloseCircleOutlined /> }
			</Tooltip>;
	}

	if (processing) {
		icon = isSalesforce ?
			<SalesforceCloudOutline /> :
			<LoadingSpinner
				size='small'
				spinning />;
	}

	return (
		<div
			className={ classNames(
				'processing-icon',
				{
					error,
					success
				},
				className
			) }>
			{ icon }
		</div>
	);
};
